<template>
  <v-container fluid>
      <v-row>
          <v-col cols=12>
              <v-card
                :loading="loading"
                :disabled="loading"
              >
                  <v-toolbar color="secondary" dark>
                    <v-toolbar-title>
                        <v-icon left>mdi-clipboard-text</v-icon>Payouts
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items class="hidden-sm-and-down">
                        <v-btn text @click="filters = !filters">{{filters ? 'Hide' :'Show'}} Filters</v-btn>
                    </v-toolbar-items>
                  </v-toolbar>
                  <v-card-text>
                    <v-card v-if="filters">
                        <v-card-text>
                            <v-row>
                                <v-col cols=3>
                                    <v-text-field v-model="filter.invoiceNumber" label="Invoice Number" clearable/>
                                </v-col>
                                <v-col cols=3>
                                    <v-text-field v-model="filter.orderId" label="#Order" clearable/>
                                </v-col>
                                <v-col cols=3>
                                    <v-select
                                        v-model="filter.statusId"
                                        :items="statuses"
                                        label="Status"
                                        multiple
                                        clearable
                                    />
                                </v-col>
                                <v-col cols=3>
                                    <shop-select
                                        v-model="filter.shopId"
                                        style="align-items:center"
                                    ></shop-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols=3>
                                    <v-select
                                        v-model="filter.typeId"
                                        :items="types"
                                        label="Type"
                                        multiple
                                        clearable
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-menu
                                        ref="rangeMenu"
                                        v-model="rangeMenu"
                                        :close-on-content-click="false"
                                        :return-value.sync="date"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="filter.dateBetween"
                                                label="Date Range"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                clearable
                                            ></v-text-field>
                                        </template>
                                            <v-date-picker
                                                v-model="filter.dateBetween"
                                                no-title
                                                scrollable
                                                range
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="rangeMenu = false">Cancel</v-btn>
                                                <v-btn text color="primary" @click="$refs.rangeMenu.save(date)">OK</v-btn>
                                            </v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn @click="fetchPayouts">Search</v-btn>
                        </v-card-actions>
                    </v-card>
                    <v-data-table
                        :items=payouts
                        :headers="headers"
                        :server-items-length="total"
                        :options.sync="options"
                    > 
                        <template #[`item.created_at`]="{item}">
                            {{ item.created_at | formatDate }}
                        </template>
                        <template #[`item.invoice.orderId`]="{item}">
                            {{ item.invoice.orderId }} <v-btn icon x-small :href="'/orders/view/' + item.invoice.orderId" target="_blank">
                                <v-icon>mdi-open-in-new</v-icon>
                            </v-btn>
                        </template>
                        <template #[`item.statusId`]="{item}">
                            <v-chip small :color="getPayoutStatusColor(item.statusId)">{{item.statusId}}</v-chip>
                        </template>
                        <template #[`item.amount`]="{item}">
                            {{ item.amount | currency(item.invoice.currency) }}
                        </template>
                        <template #[`item.payouts`]="{item}">
                            {{ item.payouts.reduce((acc, payout) => payout.statusId=='close' ? acc + payout.amount : acc, 0) | currency(item.invoice.currency) }}
                        </template>
                    
                    
                    </v-data-table>
                </v-card-text>
              </v-card>
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex'
import ShopSelect from "@components/forms/select/Shop.vue";
export default {
    name: 'InvoiceList',
    components:{
        ShopSelect
    },
    data: () => ({
        rangeMenu:false,
        date:null,
        filters:false,
        filter:{},
        headers:[
            {text:'Invoice', value:'invoice.invoiceNumber'},
            {text:'Order #', value:'invoice.orderId'},
            {text:'Date', value:'created_at'},
            {text:'Status', value:'statusId'},
            {text:'Amount', value:'amount'},
            {text:'Type', value:'typeId'},
        ],
        statuses:[
            {id:'new', text:'New'},
            {id:'open', text:'Open'},
            {id:'close', text:'Close'},
            {id:'error', text:'Error'}
        ],
        types:[
            {id:'cash', text:'Cash'},
            {id:'card', text:'Card'},
            {id:'virement', text:'Virement'},
            {id:'credit', text:'Client Credit'},
            {id:'deposit', text:'Deposit'},
            {id:'tpe_xperience', text:'TPE Xperience'},
        ],
        options: { itemsPerPage: 15, sortBy: ["id"], sortDesc: [true] },
    }),
    computed:{
        ...mapGetters("payouts", [
            "payouts", "total", "loading"
        ])
    },
    filters:{
        formatDate (value, hour) {
            if (!value) return '';
            return hour ? moment(value).format('DD/MM/YYYY, HH:mm:ss') : moment(value).format('DD/MM/YYYY');
        }
    },
    watch:{
        options: {
            handler () {
                this.fetchPayouts();
            },
            deep: true
        }
    },
    methods:{
        ...mapActions("payouts", {getPayouts:'list', export:'export'}),
        fetchPayouts(){
            this.getPayouts({
                pagination: this.options,
                filters: this.filter
            })
        },
        getPayoutStatusColor(status){
            switch (status) {
                case 'open':
                    return 'orange'
                case 'paid':
                    return 'green'
                case 'cancel':
                    return 'red lighten-3'
                default:
                    break;
            }
        },
        exportInvoices(){
            this.export({
                filters: this.filter
            })
        }
    }
}
</script>

<style>

</style>